"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var dayjs_1 = __importDefault(require("dayjs"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@21st-night/core");
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            display: 'flex',
            transition: 'padding 200ms',
            padding: theme.spacing(1, 0),
        },
        divider: {
            borderBottom: "1px solid " + theme.palette.grey[300],
        },
        dayLabel: {
            fontWeight: 600,
            fontSize: '1.2em',
            color: theme.palette.grey[400],
            padding: theme.spacing(1.5, 2, 1, 0),
            textAlign: 'right',
            minWidth: 110,
        },
        dayLabelDate: {
            fontWeight: 400,
            fontSize: '1em',
        },
        dayContent: {
            flex: 1,
        },
        pastDay: {
            color: theme.palette.grey[500],
        },
        currentDay: {
            color: theme.palette.grey[700],
        },
    });
});
var StudyPlanDay = function (_a) {
    var dateProp = _a.date, divider = _a.divider, children = _a.children, other = __rest(_a, ["date", "divider", "children"]);
    var classes = exports.useStyles();
    var date = dayjs_1.default(dateProp);
    var dayLabelClass = react_1.useCallback(function (date) {
        if (dayjs_1.default().isBefore(date, 'day')) {
            return classes.pastDay;
        }
        if (dayjs_1.default().isSame(date, 'day')) {
            return classes.currentDay;
        }
        return '';
    }, [classes.currentDay, classes.pastDay]);
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.root, divider && classes.divider) }, other),
        react_1.default.createElement("div", { className: clsx_1.default(classes.dayLabel, dayLabelClass(date)) },
            dayjs_1.default(date).format('dddd'),
            react_1.default.createElement("br", null),
            react_1.default.createElement("span", { className: classes.dayLabelDate }, dayjs_1.default(date).format('MMM D'))),
        react_1.default.createElement("div", { className: classes.dayContent }, children)));
};
// export default StudyPlanDay;
exports.default = react_1.default.memo(StudyPlanDay, function (prev, next) {
    if (next.isDraggingOver || prev.isDraggingOver) {
        return false;
    }
    var childrenEqual = core_1.compareChildren(prev.children, next.children);
    if (childrenEqual) {
        var prevGrandchildren_1 = [];
        var nextGrandchildren_1 = [];
        react_1.default.Children.toArray(prev.children).forEach(function (child) {
            if (typeof child === 'object' && child.props && child.props.children) {
                prevGrandchildren_1 = __spreadArray(__spreadArray([], __read(prevGrandchildren_1)), __read(child.props.children));
            }
        });
        react_1.default.Children.toArray(next.children).forEach(function (child) {
            if (typeof child === 'object' && child.props && child.props.children) {
                nextGrandchildren_1 = __spreadArray(__spreadArray([], __read(nextGrandchildren_1)), __read(child.props.children));
            }
        });
        return core_1.compareChildren(prevGrandchildren_1, nextGrandchildren_1);
    }
    return false;
});
//# sourceMappingURL=StudyPlanDay.js.map